import {css} from '@emotion/css';

import {colours, spacing} from '../../../../styles/js/variables';
import {mq, Breakpoints} from '../../../../styles/js/mixins';

const styles = {
  container: css`
    label: knowledgeLayout__container;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    > .row {
      flex-grow: 1;
    }
  `,
  content: css`
    label: knowledgeLayout__content;
    margin-bottom: ${spacing.M};
    color: ${colours.font.BLACK};
    border-left: 1px solid ${colours.border.LIGHT_GRAY};

    ${mq(Breakpoints.TABLET)} {
      margin-bottom: ${spacing.L};
    }
  `,
};

export default styles;
